export default "__VITE_ASSET__m$LCcvRT__"